import React, { useState, useEffect, useCallback } from 'react';

const API_COM = 'https://centrocomunicar.com/api-comunicar/endpoints/articulos_comentarios.php';

const IconCheck  = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><polyline points="20 6 9 17 4 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconTrash  = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><polyline points="3 6 5 6 21 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M10 11v6M14 11v6M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconClose  = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconMsg    = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconRefresh = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M23 4v6h-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);

const S = {
  page:   { padding: '1.5rem', maxWidth: 1000, margin: '0 auto', fontFamily: "'DM Sans', sans-serif" },
  header: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.5rem', flexWrap: 'wrap', gap: '.8rem' },
  h1:     { fontSize: '1.4rem', fontWeight: 700, color: '#111614', margin: 0 },
  btn:    { display: 'inline-flex', alignItems: 'center', gap: '.4rem', padding: '.5rem 1rem', borderRadius: 100, fontFamily: 'inherit', fontSize: '.82rem', fontWeight: 700, cursor: 'pointer', border: 'none', transition: 'all .2s' },
  toast:  { position: 'fixed', bottom: '2rem', right: '2rem', zIndex: 9999, background: '#111614', color: '#fff', borderRadius: 12, padding: '.8rem 1.2rem', display: 'flex', alignItems: 'center', gap: '.6rem', fontSize: '.85rem', fontWeight: 600 },
};

export default function AdminComentariosArticulos() {
  const [comentarios, setComentarios] = useState([]);
  const [loading,     setLoading]     = useState(true);
  const [filtro,      setFiltro]      = useState('pendientes'); // pendientes | aprobados | todos
  const [toast,       setToast]       = useState(null);

  const showToast = (msg, tipo = 'ok') => {
    setToast({ msg, tipo });
    setTimeout(() => setToast(null), 3000);
  };

  const fetchComentarios = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${API_COM}?action=admin_list`);
      const j = await r.json();
      if (j.success) setComentarios(j.data || []);
    } catch { showToast('Error cargando comentarios', 'error'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchComentarios(); }, [fetchComentarios]);

  const aprobar = async (com) => {
    try {
      const r = await fetch(`${API_COM}?action=aprobar`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: com.id }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      setComentarios(cs => cs.map(c => c.id === com.id ? { ...c, aprobado: 1 } : c));
      showToast('Comentario aprobado y publicado');
    } catch (e) { showToast(e.message, 'error'); }
  };

  const eliminar = async (com) => {
    if (!window.confirm(`¿Eliminar el comentario de "${com.nombre}"?`)) return;
    try {
      const r = await fetch(`${API_COM}?action=eliminar`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: com.id }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      setComentarios(cs => cs.filter(c => c.id !== com.id));
      showToast('Comentario eliminado');
    } catch (e) { showToast(e.message, 'error'); }
  };

  const filtrados = comentarios.filter(c => {
    if (filtro === 'pendientes') return !c.aprobado;
    if (filtro === 'aprobados')  return !!c.aprobado;
    return true;
  });

  const pendientesCount = comentarios.filter(c => !c.aprobado).length;

  return (
    <div style={S.page}>

      {toast && (
        <div style={{ ...S.toast, borderLeft: `3px solid ${toast.tipo === 'ok' ? '#82D8B3' : '#dc2626'}` }}>
          {toast.tipo === 'ok' ? <IconCheck/> : <IconClose/>} {toast.msg}
        </div>
      )}

      <div style={S.header}>
        <div>
          <h1 style={S.h1}>
            <IconMsg/> Comentarios de artículos
            {pendientesCount > 0 && (
              <span style={{ marginLeft: '.6rem', background: '#fef3c7', color: '#92400e', fontSize: '.72rem', fontWeight: 700, padding: '.2rem .65rem', borderRadius: 100 }}>
                {pendientesCount} pendientes
              </span>
            )}
          </h1>
          <p style={{ fontSize: '.82rem', color: '#5a6a63', margin: '.2rem 0 0' }}>
            {comentarios.length} comentarios en total
          </p>
        </div>
        <button style={{ ...S.btn, background: 'none', border: '1.5px solid rgba(130,216,179,.3)', color: '#5a6a63' }} onClick={fetchComentarios}>
          <IconRefresh/> Actualizar
        </button>
      </div>

      {/* Filtros */}
      <div style={{ display: 'flex', gap: '.5rem', marginBottom: '1.2rem', flexWrap: 'wrap' }}>
        {[
          { id: 'pendientes', label: `⏳ Pendientes (${comentarios.filter(c=>!c.aprobado).length})` },
          { id: 'aprobados',  label: `✅ Aprobados (${comentarios.filter(c=>c.aprobado).length})` },
          { id: 'todos',      label: `📋 Todos (${comentarios.length})` },
        ].map(f => (
          <button key={f.id}
            style={{ ...S.btn, background: filtro === f.id ? '#111614' : 'none', color: filtro === f.id ? '#82D8B3' : '#5a6a63', border: '1.5px solid', borderColor: filtro === f.id ? 'transparent' : 'rgba(130,216,179,.25)' }}
            onClick={() => setFiltro(f.id)}
          >
            {f.label}
          </button>
        ))}
      </div>

      {/* Lista */}
      {loading ? (
        <div style={{ textAlign: 'center', padding: '3rem', color: '#5a6a63' }}>Cargando comentarios…</div>
      ) : filtrados.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '3rem', color: '#5a6a63', background: '#fff', borderRadius: 14, border: '1.5px solid rgba(130,216,179,.15)' }}>
          {filtro === 'pendientes' ? '🎉 No hay comentarios pendientes de revisión.' : 'Sin comentarios en esta categoría.'}
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '.8rem' }}>
          {filtrados.map(com => (
            <div key={com.id} style={{
              background: '#fff',
              borderRadius: 14,
              border: `1.5px solid ${!com.aprobado ? '#fde68a' : 'rgba(130,216,179,.15)'}`,
              padding: '1rem 1.2rem',
              display: 'flex', gap: '1rem', alignItems: 'flex-start',
            }}>
              {/* Avatar */}
              <div style={{
                width: 40, height: 40, borderRadius: '50%', flexShrink: 0,
                background: com.aprobado ? '#edfaf4' : '#fffbeb',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontWeight: 700, fontSize: '1rem',
                color: com.aprobado ? '#4db88a' : '#92400e',
              }}>
                {(com.nombre || '?')[0].toUpperCase()}
              </div>

              {/* Info */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem', flexWrap: 'wrap', marginBottom: '.3rem' }}>
                  <strong style={{ fontSize: '.9rem', color: '#111614' }}>{com.nombre}</strong>
                  {com.email && <span style={{ fontSize: '.75rem', color: '#9ca3af' }}>{com.email}</span>}
                  <span style={{
                    fontSize: '.68rem', fontWeight: 700, padding: '.15rem .55rem', borderRadius: 100,
                    background: com.aprobado ? '#d1fae5' : '#fef3c7',
                    color: com.aprobado ? '#065f46' : '#92400e',
                  }}>
                    {com.aprobado ? '✅ Publicado' : '⏳ Pendiente'}
                  </span>
                  <span style={{ fontSize: '.72rem', color: '#9ca3af', marginLeft: 'auto' }}>
                    {new Date(com.created_at).toLocaleDateString('es-PE', { day:'2-digit', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit' })}
                  </span>
                </div>

                {com.articulo_titulo && (
                  <p style={{ fontSize: '.75rem', color: '#4db88a', margin: '0 0 .4rem', fontWeight: 600 }}>
                    📝 {com.articulo_titulo}
                  </p>
                )}

                <p style={{ fontSize: '.88rem', color: '#374151', lineHeight: 1.6, margin: '0 0 .5rem', wordBreak: 'break-word' }}>
                  {com.texto}
                </p>

                {com.likes > 0 && (
                  <span style={{ fontSize: '.72rem', color: '#9ca3af' }}>👍 {com.likes} likes</span>
                )}
              </div>

              {/* Acciones */}
              <div style={{ display: 'flex', gap: '.4rem', flexShrink: 0 }}>
                {!com.aprobado && (
                  <button
                    style={{ ...S.btn, background: '#edfaf4', color: '#065f46', padding: '.4rem .8rem' }}
                    onClick={() => aprobar(com)}
                    title="Aprobar y publicar"
                  >
                    <IconCheck/> Aprobar
                  </button>
                )}
                <button
                  style={{ ...S.btn, background: '#fef2f2', color: '#dc2626', padding: '.4rem .8rem' }}
                  onClick={() => eliminar(com)}
                  title="Eliminar"
                >
                  <IconTrash/>
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}